// extracted by mini-css-extract-plugin
export default {"container":"PremiumBanner_container__qbAZo","content":"PremiumBanner_content__32plu"};